import type { AdminRouterContext } from '@/lib/router-context'
import { assertNotSalesDemoOrganization } from '@/lib/services/sales-demos/sales-demos.guard'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const integrationsLayoutLoader = ({
  context,
  params,
}: {
  context: Pick<AdminRouterContext, 'queryClient'>
  params: { orgId: number }
}): ReturnType<typeof assertNotSalesDemoOrganization> =>
  assertNotSalesDemoOrganization(context.queryClient, params.orgId)

export const Route = createFileRoute('/_authenticated/$orgId/settings/integrations')({
  component: Outlet,
  loader: integrationsLayoutLoader,
})
